import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/user-roles/user-permissions";

export const Route = createFileRoute("/admin/_user-roles/user-permissions")({
  component: Page,
});
